
import React from 'react';
import styles from './_dealer-detail.module.scss';
import { DealerReport } from '../../../../Models/DealerReport';
import { GenericGrid } from '@amsanalytics/react-shared-library';
import { GridDetailRowProps } from '@progress/kendo-react-grid';
import { ExternalLinkCell, InternalReportLinkCell } from '../../../Controls/ExternalLink/ExternalLink';
import { Dealer } from '../../../../Models/Dealer';
import { useSelector } from 'react-redux';
import { AppState } from '../../../../Store/rootReducer';
import { formatMonthYear, sortByYearThenMonthDescending } from '../../../../Helpers/Utilities';
import { useNavigate } from 'react-router';
import { DealerGroup } from '../../../../Models/DealerGroup';
import { User } from '../../../../Models/User';
import { PhoneNumberCell } from '../../../PhoneNumberGridCell/PhoneNumberGridCell';

export default function DealerDetail (props:  GridDetailRowProps) {
  const dealer: Dealer = props.dataItem;
  const allReports = useSelector((state: AppState) => state.performanceReport.dealerReports);
  const dealerGroups = useSelector((state: AppState) => state.dealers.dealerGroups);
  const dealerReports = allReports.filter(dr => dr.clientId === dealer.id);
  const navigate = useNavigate();
  const dealerGroupsForDealer = dealer.dealerGroupLookupInfoList.map(dg => dealerGroups.find(d => d.id === dg.dealerGroupId)!);
  return (
    <div className={styles.dealerDetailContainer}>
      <div className={styles.dealerReports}>
        <GenericGrid<DealerReport>
          disableEditing={true}
          disableAdding={true}
          disableGrouping={true}
          itemName='Dealer Inputs'
          itemNameStyle={{ color: '#d95137' }}
          style={{ display: 'flex', flex: 1, height: '400px' }}
          items={dealerReports?.sort(sortByYearThenMonthDescending).map((dealerReport: DealerReport) => {
            return {
              ...dealerReport,
              period: formatMonthYear(dealerReport.month, dealerReport.year),
              date: new Date(dealerReport.date),
            };
          }) ?? []}
          selectedField={'selected'}
          onItemSelected={(item: DealerReport) => {
            if (item) {

            }
          }}
          columns={[
            { field: '', title: ' ', cell: (props: any) => <InternalReportLinkCell {...props} 
              icon={<span style={{color: '#d95137', fontSize: '25px', cursor: 'pointer'}} 
              className="k-icon k-font-icon k-i-track-changes" />}
              onReportClick={(dealerReport: DealerReport) => {
                navigate(`/performanceReporting/${dealerReport.id}`)
              }} />, 
              width: '50px', preventFiltering: true
            },
            { field: "period", title: "Period", width: '100px', preventFiltering: true },
            { field: "status", title: "Status" },
            { field: "date", width: "120px", title: "Last Modified", format: "{0:d}", preventFiltering: true }            
          ]}
        />
      </div>
      <div className={styles.dealerUsers}>
        <GenericGrid<User>
          items={dealer.users}
          style={{ display: 'flex', flex: 1, height: '400px' }}
          itemName={"Users"}
          itemNameStyle={{ color: '#d95137' }}
          disableAdding={true}          
          disableEditing={false}
          disableFiltering={true}
          useIconButtons={true}
          disablePdfExporting={true}
          disableExcelExporting={true}
          onItemSelected={(user: User) => {
            navigate(`/userManagement`);
          }}
          disableGrouping={true}
          columns={[
            { title: "First Name", field: "firstName", width: '120px' },
            { title: "Last Name", field: "lastName", width: '120px'  },
            { title: "Username", field: "adUserId", width: '120px'  },
            { title: "Title", field: "title", width: '120px'  },
            { title: "Email", field: "emailAddress", width: '120px'  },
            { title: "Mobile", field: "mobilePhone", cell: (props: any) => <PhoneNumberCell {...props} />, width: '120px'  }
          ]}
        />
      </div>        
      <div className={styles.dealerGroups}>
        <GenericGrid<DealerGroup>
          style={{ display: 'flex', flex: 1, height: '400px' }}
          disableAdding={true}
          disableEditing={true}
          disableFiltering={true}
          useIconButtons={true}
          disablePdfExporting={true}
          disableExcelExporting={true}
          disableGrouping={true}
          itemName='Dealer Groups'
          itemNameStyle={{ color: '#d95137' }}
          items={dealerGroupsForDealer}
          columns={[
            { field: "name", title: "Name"}
          ]}
        />
      </div>
    </div>
  );
}
